/**
 * Created by lenovo on 2017/3/31.
 */
import xhr from './../xhr/'

import { ellaUrl } from '../../path.config'

class roleService {
    //角色列表
    getListRole ({data}={}) {
        return xhr({
            method: 'post',
            url: ellaUrl+'/back/role/list',
            body : data,
        })
    }
    //角色删除
    roleDel (id) {
        return xhr({
            method: 'get',
            url: ellaUrl+'/role/doDelete/'+id,
        })
    }
    //角色添加初始化
    roleToAdd(userId){
        return xhr({
            method: 'get',
            url: ellaUrl+'/role/toAdd/'+userId,
        })
    }
    //角色添加 编辑提交
    roleDoAddOrUpdate({data}={}) {
        return xhr({
            method: 'post',
            url: ellaUrl+'/role/doAddOrUpdate',
            body : data,
        })
    }
    //角色编辑初始化
    roleToUpdate(roleId,userId){
        return xhr({
            method: 'get',
            url: ellaUrl+"/role/toUpdate/"+roleId+"/"+userId,
        })
    }
}





// 实例化后再导出
export default new roleService()


// WEBPACK FOOTER //
// ./modules/services/ella/roleService.js